export * from './isMobile';
export { default } from './isMobile';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ismobilejs/esm/index.js
// module id = 877
// module chunks = 2